import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function appidea() {
  return (
    <section className="app_amj p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>The App Idea</h2>
            <p>
              Client had asked for an app that would reflect her vision. The app
              idea was simple yet comprehensive, clearly laid out, and doable.
              Yet, we knew we had to come up with a top-notch application
              because our target users, themselves, were sophisticated
              professionals who would prefer value and relevance above
              everything else.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1 "
          >
            <StaticImage
              src="../../../images/case-studies/amj/app_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={665}
              height={664}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default appidea;
